(() => {
  const activeTriggers = new WeakMap();

  const closeDialog = (dialog) => {
    if (!dialog) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-demo-condition-dialog-open]');
    if (opener) {
      const dialogId = opener.getAttribute('aria-controls');
      const dialog = dialogId ? document.getElementById(dialogId) : null;
      if (!dialog) return;
      activeTriggers.set(dialog, opener);
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      return;
    }

    const closer = event.target.closest('[data-demo-condition-dialog-close]');
    if (closer) {
      closeDialog(closer.closest('[data-demo-condition-dialog]'));
      return;
    }

    const dialog = event.target.closest('[data-demo-condition-dialog]');
    if (dialog && event.target === dialog) closeDialog(dialog);
  });

  document.addEventListener('close', (event) => {
    const dialog = event.target.closest?.('[data-demo-condition-dialog]');
    if (!dialog) return;
    activeTriggers.get(dialog)?.focus();
    activeTriggers.delete(dialog);
  }, true);
})();
